import { Permissions } from '../../models/enums/permissions';
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { HasPermission } from '../../containers/authorization-helpers/HasPermission';
import './NavRibbon.scss';

// #region Component Props

export class NavRibbonLink {

    public url: string;
    
    public icon: string;
    
    public label: string;
    
    public permissions: Permissions[];

    public constructor(url : string, icon : string, label : string, permissions: Permissions[]) {
        this.url = url;
        this.icon = icon;
        this.label = label;
        this.permissions = permissions;
    }
}

interface IProps  {
    links: NavRibbonLink[];
}

// #endregion

export const NavRibbon = (props: IProps) => (
    <div className="row nav-ribbon">
        <div className="col nav-ribbon-elements">
            {
                props.links.map((itm : NavRibbonLink, idx: number) => 
                    <HasPermission key={ `navribbon-${ idx }`} requiredPermissions={ itm.permissions }>
                        <NavLink 
                            to={ itm.url }>
                            <i className={`la ${ itm.icon }`} />
                            { itm.label }
                        </NavLink>      
                    </HasPermission>
                )
            }            
        </div>
    </div>
)